<div class="white-box-row" *ngIf="!loadFailed; else loadError">
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "COMPANY.CHAT.TITLE" | translate }}
    </div>
    <div class="fl-r">
      <span
        class="status-badge"
        [class.status-badge--enabled]="enabled && !loading"
        [class.status-badge--loading]="loading"
      >
        {{
          (enabled
            ? "COMPANY.CHAT.STATUS-ENABLED"
            : "COMPANY.CHAT.STATUS-DISABLED"
          ) | translate
        }}
      </span>
    </div>
  </div>
  <div class="clear"></div>
  <div class="white-box-body">
    <div class="ai-setting-row">
      <p class="case-label ai-setting-description">
        {{ "COMPANY.CHAT.HINT" | translate }}
      </p>
      <mat-slide-toggle
        [checked]="enabled"
        [disabled]="loading"
        (change)="onToggle($event)"
        color="primary"
      ></mat-slide-toggle>
    </div>
  </div>
</div>

<ng-template #loadError>
  <div class="white-box-row">
    <div class="white-box-header">
      <div class="medium-title fl-l">
        {{ "COMPANY.CHAT.TITLE" | translate }}
      </div>
    </div>
    <div class="clear"></div>
    <div class="white-box-body">
      <p class="case-label error-message">
        {{ "COMPANY.CHAT.LOAD-ERROR" | translate }}
      </p>
    </div>
  </div>
</ng-template>
